import { PHILOSOPHY_IMAGE } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const PILLARS = [
    {
        n: "01",
        t: "Design first",
        d: "Every project starts with a drawing, not a discount.",
    },
    {
        n: "02",
        t: "Functionality",
        d: "How you actually live is more important than how it photographs.",
    },
    {
        n: "03",
        t: "Craftsmanship",
        d: "Every joint, every hinge, every seam — considered.",
    },
    {
        n: "04",
        t: "Long-lasting materials",
        d: "Solid timber, natural stone, real linen. Nothing pretending.",
    },
    {
        n: "05",
        t: "Personalisation",
        d: "No two Samora homes look alike. Not one.",
    },
];

const Philosophy = () => {
    const ref = useReveal();
    return (
        <section
            ref={ref}
            data-testid="philosophy-section"
            className="py-24 md:py-40 bg-samora-sand/40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-5 reveal">
                        <p className="eyebrow mb-6">Our Philosophy</p>
                        <h2
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.5rem, 5.5vw, 5rem)" }}
                        >
                            We don't decorate<br />homes.
                            <br />
                            <span className="italic font-serif text-samora-gold">
                                We design lifestyles.
                            </span>
                        </h2>
                        <p className="mt-8 text-samora-text/75 text-base md:text-lg leading-relaxed max-w-lg">
                            Samora Spaces is a lux design studio in
                            Bengaluru, taking on a small number of residential
                            projects each year — deeply, personally, and with
                            uncompromising material honesty.
                        </p>
                        <p className="mt-4 text-samora-text/75 text-base md:text-lg leading-relaxed max-w-lg">
                            Every home we build is designed around the family
                            that will live in it. Not a moodboard. Not a
                            template. You.
                        </p>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                        <div className="reveal reveal-slow">
                            <img
                                src={PHILOSOPHY_IMAGE}
                                alt="Detail of a hand-turned wooden chair leg — a study in craftsmanship"
                                className="w-full h-[540px] md:h-[640px] object-cover"
                            />
                        </div>
                        <div className="space-y-6 md:pt-16">
                            {PILLARS.map((p) => (
                                <div
                                    key={p.n}
                                    className="reveal border-t border-samora-ink/15 pt-4"
                                    data-testid={`pillar-${p.n}`}
                                >
                                    <div className="flex items-baseline gap-4">
                                        <span className="font-serif text-samora-gold text-lg">
                                            {p.n}
                                        </span>
                                        <h3 className="font-display text-2xl md:text-3xl text-samora-ink">
                                            {p.t}
                                        </h3>
                                    </div>
                                    <p className="mt-2 text-samora-text/70 text-sm md:text-base leading-relaxed pl-10">
                                        {p.d}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Philosophy;
